<div class="fund-maintenance-table-container">
  <div class="table-container">
    <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-elevation-z8">
      <ng-container matColumnDef="Funding_Source">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left" style="width: 17%;">
          Funding Source @if (!segmentSourceFilterApplied) {
          <span
            (click)="filterDropdown('Funding_Source'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (segmentSourceFilterApplied) {
          <span
            (click)="filterDropdown('Funding_Source'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element" class="text-left">{{ element.Funding_Source }}</td>
      </ng-container>
      <ng-container matColumnDef="Funding_SegmentID">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left" style="width: 17%;">
          Funding Segment ID @if (!segmentIdFilterApplied) {
          <span
            (click)="filterDropdown('Funding_SegmentID'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (segmentIdFilterApplied) {
          <span
            (click)="filterDropdown('Funding_SegmentID'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element" class="text-left">{{ element.Funding_SegmentID }}</td>
      </ng-container>
      <ng-container matColumnDef="Funding_Segment">
        <th mat-sort-header mat-header-cell *matHeaderCellDef style="width: 18%;" class="text-left">
          Funding Segment @if (!segmentNameFilterApplied) {
          <span
            (click)="filterDropdown('Funding_Segment'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (segmentNameFilterApplied) {
          <span
            (click)="filterDropdown('Funding_Segment'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element" class="text-left">{{ element.Funding_Segment }}</td>
      </ng-container>
      <ng-container matColumnDef="Funding_Owner">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-left" style="width: 18%;">Funding Owner</th>
        <td mat-cell *matCellDef="let element" style="padding: 0.5% 0.5%;">
          <div class="scrollable-height">
            <table class="scrollableLeft text-left">
              <tbody>
                @for (el of element.Funding_Owner; track el) {
                <tr>
                  <td class="table-data-font table-data p-0" style="width: 24%">{{ el?.displayName }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="Funding_Delegate">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-left" style="width:18%;">
          Funding Delegate
        </th>
        <td mat-cell *matCellDef="let element" style="padding: 0.5% 0.5%;">
          <div class="scrollable-height">
            <table class="scrollableLeft text-left">
              <tbody>
                @for (el of element.Funding_Delegate; track el) {
                <tr>
                  <td class="table-data-font table-data p-0" style="width:13%">{{ el?.displayName }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" class="text-center">
          Action
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <ng-container>
            <div class="btn-edit">
              <span class="cancel-screen-icon">
                <mat-icon class="edit-pencil" title="Click to Edit Segment" (click)="EditSegment(element)"
                  >edit</mat-icon
                >
                <mat-icon
                  class="icon-crud"
                  title="Click to Delete Segment"
                  (click)="DeleteSegmentKey(element?.Funding_SegmentID)"
                  >delete</mat-icon
                >
              </span>
            </div>
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="Reset_Filter">
        <th mat-header-cell *matHeaderCellDef style="width: 1%" class="text-center">
          @if ((segmentNameFilterApplied || segmentIdFilterApplied || segmentSourceFilterApplied)) {
          <span (click)="clearallFilter()">
            <i
              title="Reset Filters"
              class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
            ></i>
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element"></td>
      </ng-container>

      <mat-menu #contextMenu="matMenu">
        <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <input
            matInput
            type="text"
            class="searchoption"
            (keydown)="$event.stopPropagation()"
            class="form-control filter-search-bar"
            [(ngModel)]="searchTxt"
            placeholder="Search"
          />
          <mat-selection-list
            class="filter-list-container"
            (selectionChange)="selectionChange($event)"
            [disableRipple]="true"
            [(ngModel)]="filValue"
          >
            @for (row of filterLists | search : searchTxt; track row) {
            <mat-list-option checkboxPosition="before" [value]="row">
              {{ row }}
            </mat-list-option>
            }
          </mat-selection-list>
          <span
            style="cursor:pointer; float: right;padding-right: 70px;"
            class="small localApplyButton"
            (click)="applyLocalFilter()"
            >Apply</span
          >
          <span
            style="cursor:pointer; float: right;padding-right: 22px;"
            class="small localApplyButton"
            (click)="clearLocalFilter()"
            >Clear</span
          >
        </div>
      </mat-menu>

      <tr class="tableHeight" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="tableHeight" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <ng-container>
      <mat-paginator
        #paginator
        [pageSizeOptions]="[10, 20, 30]"
        showFirstLastButtons
        aria-label="Select page of listed group"
      >
      </mat-paginator>
    </ng-container>
  </div>
</div>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalEditSegment
  class="modal-demo edit-segment-popups"
  (closeModal)="hidepopup('editSegment')"
>
  <ng-container class="app-modal-header">Edit Segment</ng-container>
  <ng-container class="app-modal-body">
    @if (isEditSegment) {
    <app-edit-segment
      (SegmentEditById)="segmentEditSubmit($event)"
      [isEditSegment]="isEditSegment"
      [editSegmentDataSource]="editSegmentDataSource"
    >
    </app-edit-segment>
    }
  </ng-container>
</app-modal>
